import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Curriculum } from '../academicHistorytabs/Curriculum/Curriculum';
import ProgressInCurrentPeriod from '../academicHistorytabs/ProgressInCurrentPeriod/ProgressInCurrentPeriod';
import { Titulation } from '../academicHistorytabs/Titulation/Titulation';
import GradesHistory from '../academicHistorytabs/GradesHistory/GradesHistory';
import { StudyPlanEnrollmentsInfo } from '../../../../StudentManagement/StudentFile/types';
import CurriculumInfo from './CurriculumInfo';

interface AcademicHistoryTabsProps {
  studyPlanEnrollmentId: string | undefined;
  studyPlanEnrollmentsInfo: StudyPlanEnrollmentsInfo[];
}

export default function AcademicHistoryTabs({
  studyPlanEnrollmentId,
  studyPlanEnrollmentsInfo,
}: AcademicHistoryTabsProps) {
  const { t } = useTranslation();
  const tabsPrefix = 'studentManagement.academicHistory';

  const tabs = useMemo(() => {
    return [
      {
        name: t('tabs.progressInCurrentPeriod'),
        path: '',
        content: (
          <ProgressInCurrentPeriod
            studyPlanEnrollmentId={studyPlanEnrollmentId}
          />
        ),
      },
      {
        name: t('tabs.curriculum'),
        path: '',
        content: (
          <Curriculum studyPlanEnrollmentIdStr={studyPlanEnrollmentId} />
        ),
      },
      {
        name: t('tabs.history'),
        path: '',
        content: (
          <GradesHistory studyPlanEnrollmentId={studyPlanEnrollmentId} />
        ),
      },
      {
        name: t('tabs.titulation.title'),
        path: '',
        content: <Titulation studyPlanEnrollmentId={studyPlanEnrollmentId!} />,
      },
    ];
  }, [studyPlanEnrollmentId, t]);

  return (
    <Tabs defaultTab={tabs[0].name}>
      <CurriculumInfo
        studyPlanEnrollmentId={studyPlanEnrollmentId}
        studyPlanEnrollmentsInfo={studyPlanEnrollmentsInfo}
      />
      <TabsList>
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            id={tab.name}
            children={t(`${tabsPrefix}.${tab.name}`)}
          />
        ))}
      </TabsList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.name} id={tab.name} children={tab.content} />
        ))}
      </TabPanels>
    </Tabs>
  );
}
